import UAParser from 'ua-parser-js'

export const userAgentParser = new UAParser(window.navigator.userAgent)

/**
 * Parses `window.navigator.userAgent` rather than
 * using `window.navigator.platform` since the latter
 * is being deprecated and doesn't work with SSR.
 *
 * @returns {boolean} true if the client is a macOS platform.
 */
export const isMac = userAgentParser.getOS().name === 'Mac OS'
